



























import Vue from 'vue'

export default Vue.extend({
  name: 'AddMovieDialog',
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    youtubeLink: '',
    loading: false,
    youtubeLinkRules: [
      (v: string) =>
        v.startsWith('https://youtu.be') ||
        'Enter correct Youtube share link eg. https://youtu.be/XXXXX',
    ],
  }),
  methods: {
    init: function () {
      this.youtubeLink = ''
      ;(this.$refs.youtubeLinkFormRef as any).resetValidation()
    },
    cancelClick: function () {
      this.$emit('input', false)
      this.init()
    },
    addMovieClick: function () {
      this.loading = true
      const userId = this.$store.state.authentication.user
        ? this.$store.state.authentication.user.id
        : 'x-unknown'
      const formData = new FormData()
      formData.append('url', this.youtubeLink)
      formData.append('name', 'Youtube movie')
      formData.append('description', 'Youtube movie')
      formData.append('domain', 'client/user/' + userId + '/proj/yt')
      this.$api
        .post('/multimedia', formData)
        .then((response) => {
          this.$emit('youtubeMovieAdded', Object.assign({}, response.data))
          this.init()
          this.$emit('input', false)
        })
        .catch(() =>
          this.$store.dispatch('alert/error', 'Problems with adding the movie')
        )
        .finally(() => (this.loading = false))
    },
  },
})
